import { Select } from 'antd'
import styled from 'styled-components'

export const RootZoomWrapper = styled(Select)`
  width: 65px;
`
